import { Component, input, InputSignal } from '@angular/core';

import { CmsStyles } from '@shared/directives/cms-styles/cms-styles.directive';
import { TrustHtmlPipe } from '@shared/pipes/trust-html/trust-html.pipe';
import { CopyrightBlock } from '@core/cms/landing.cms';

/** Renders the `footer-sections.copyrigt-block` copyright notice. */
@Component({
    selector: 'app-footer-copyright',
    imports: [CmsStyles, TrustHtmlPipe],
    templateUrl: './footer-copyright.html',
    styleUrl: './footer-copyright.scss',
})
export class FooterCopyright {
    /** The CMS copyright block to render. */
    public readonly copyright: InputSignal<CopyrightBlock> = input.required<CopyrightBlock>();
}
